export default "__VITE_ASSET__DujoCIxv__"